import styled from 'styled-components';
import { InteractiveRenderer } from 'pxc-editor-material-svg-rendering';

export const AreaWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
`;

export const SchemaSvgRenderingAreaStyled = styled(InteractiveRenderer)`
  position: absolute;
  x: 0;
  y: 0;
`;
